var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition-group",
    {
      staticClass: "build-grid",
      attrs: { name: "block-swap", tag: "div", "aria-hidden": "true" },
    },
    _vm._l(_vm.blocks, function (block) {
      return _c(
        "div",
        {
          key: block.id,
          class: [
            "build-block",
            { rotating: block.id === _vm.rotatingBlockId },
          ],
          style: { "--block-accent": block.color },
        },
        [
          block.icon
            ? _c("v-icon", { attrs: { color: "white", size: "22" } }, [
                _vm._v(_vm._s(block.icon)),
              ])
            : _vm._e(),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }